<template>
  <div>
    <list
      row-key="FreightId"
      ref="list"
      unit="运费模板"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="模板名称">
          <el-input v-model="params.TemplateName" placeholder="请输入模板名称" clearable />
        </el-form-item>
        <el-form-item label="配送范围">
          <el-select v-model="params.DeliveryRange" placeholder="请选择配送范围" clearable>
            <el-option label="本地" :value="1"></el-option>
            <el-option label="异地" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送方式">
          <el-select v-model="params.DeliveryWay" placeholder="请选择配送方式" clearable>
            <el-option label="快递" :value="0"></el-option>
            <el-option label="自提" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否默认">
          <el-select v-model="params.IsDefault" placeholder="请选择是否默认" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">   
        <el-table-column prop="TemplateName" label="模板名称" />
        <el-table-column prop="DeliveryRange" label="配送范围">
          <template slot-scope="{row}">
            <span v-if="row.DeliveryRange==1">本地</span>
            <span v-if="row.DeliveryRange==0">异地</span>
          </template>
        </el-table-column>
        <el-table-column prop="DeliveryWay" label="配送方式">
          <template slot-scope="{row}">
            <span v-if="row.DeliveryWay==0">快递</span>
            <span v-else-if="row.DeliveryWay==1">自提</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="IsDefault" label="是否默认" width="80px" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.IsDefault==0" type="danger">否</el-tag>
            <el-tag v-else-if="row.IsDefault==1" type="success">是</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="State" label="状态" width="80px" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.State==0" type="danger">停用</el-tag>
            <el-tag v-else-if="row.State==1" type="success">启用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sale/freight").default,
      params: {
        TemplateName: "",
        DeliveryRange: null,
        DeliveryWay: null,
        State: null,
      },
    };
  },
  methods: {
    // getDataFunc(params) {
    //   return new Promise((resolve,reject) => {
    //     resolve({Data:[]})
    //   })
    // },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>